/**
 * Indian Rupee currency formatter — used site-wide.
 * Whole rupees only (no paise) for clean editorial display.
 */
const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/**
 * Format an integer rupee amount as "₹2,800".
 */
export const formatINR = (amount) => {
  const n = Number(amount) || 0;
  return inrFormatter.format(Math.round(n));
};

/**
 * Format an amount that arrived as Stripe-style minor units (paise/cents).
 * Stripe returns amount_total in the smallest unit; for INR this is paise.
 */
export const formatINRFromMinor = (minor) => formatINR((Number(minor) || 0) / 100);
